// 読み込みの状態を管理する
import { isInitialized } from '@/initProcess';
import state from '@/store/login/state';
import { inject, InjectionKey, provide, reactive, readonly } from 'vue';

type LoadingStateType = {
  // 表示するかどうかの判定値
  isLoading: boolean;
  loadingData: boolean;
};

type LoadingStoreType = ReturnType<typeof loadingStore>;
export const loadingStoreKey: InjectionKey<LoadingStoreType> = Symbol('loadingStore');

/**
 *
 */
export const loadingStore = () => {
  const state = reactive<LoadingStateType>({
    isLoading: true,
    loadingData: true,
  }) as LoadingStateType;

  const already = () => {
    if (!state.loadingData) state.isLoading = false;
  };

  const init = () => {
    state.isLoading = true;
    state.loadingData = true;
  };

  // 50ms毎に、indexedDBにデータが読み込まれているかチェックする
  const checkLoadingData = () => {
    // テスト用（injectが機能しているかどうか
    // setInterval(() => {
    //   state.isLoading = !state.isLoading;
    // }, 5000);

    setInterval(() => {
      if (isInitialized()) {
        state.loadingData = false;
        // console.log('起きてんの,false');
      } else {
        state.loadingData = true;
        // console.log('起きてんの,true');
      }
    }, 50);
  };

  return readonly({
    state,
    actions: {
      already,
      init,
      checkLoadingData,
    },
  });
};

/**
 *
 */
export const provideLoadingStore = () => {
  // console.log('provideされたよおおお');
  return provide(loadingStoreKey, loadingStore());
};

/**
 *
 */
export const useLoadingStore = () => {
  const store = inject(loadingStoreKey);
  if (!store) throw new Error('LoadingStore is undefined');
  store.actions.init();
  // 監視の起動
  store.actions.checkLoadingData();
  return store;
};

function delay(n) {
  return new Promise(function (resolve) {
    setTimeout(resolve, n * 1000);
  });
}
